import React from "react";

import { Container, Row, Col, Button } from "reactstrap";
import { Helmet } from "react-helmet";

import NavbarPrimary from "../sections/NavbarPrimary.js";
import Footer from "../sections/Footer.js";
import HtxMixingService from "../headers/HtxMixingService.js";
import PreFooter from "../sections/PreFooter.js";
import IntelMain from "../blogs/IntelMain.js";

function HtxMixingServiceMain() {
  const style = { width: "100%" };
  React.useEffect(() => {
    document.body.classList.add("index");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (
      window.location.href.lastIndexOf("#") > 0 &&
      document.getElementById(href)
    ) {
      document.getElementById(href).scrollIntoView();
    }
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <Helmet>
        <title>CrypTegridy - HTX Mixing Service</title>
        <meta name="description" content="An in-depth analysis of the HTX mixing service and its implications for the crypto industry." />
        <meta name="keywords" content="CrypTegridy, HTX, mixing service, crypto, security, protection, intelligence" />
      </Helmet>
      <NavbarPrimary />
      <div className="wrapper">
        <Button
          className="btn-icon-only back-to-top text-lowercase text-default show"
          color="info"
          name="button"
          type="button"
          onClick={() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
          }}
        >
          &alpha;
        </Button>
        <HtxMixingService />
        <section className="section">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h6 className="category">January 21, 2024</h6>
                <h3 className="title">
                  Some Context
                </h3>
                <p className="font-weight-normal">
                  &#8220;Huobi&#8221; was founded in 2013 by Li Lin in Beijing, China 
                  and quickly became a leading crypto asset exchange not only in China 
                  but internationally. The exchange operated without any real regulatory 
                  hurdles to overcome, by 2018 the exchange known at this time as 
                  &#8220;Huobi Global Limited &#40;Seychelles&#41;&#8221; and still 
                  controlled by Li Lin. In 2018 Li Lin made a takeover bid and bought 
                  all the shares in a Hong Kong stock exchange listed company &#40;Stock 
                  Code 1611&#41;.
                  <br></br>
                </p>
                <p className="font-weight-normal">
                  Now headquartered in the <a href="https://en.wikipedia.org/wiki/Hong_Kong#Government_and_politics" 
                  target="_blank" rel="noreferrer" className=" text-info">Hong Kong SAR</a> the 
                  exchange continued to expand taking advantage of the increase in popularity 
                  of crypto assets during the Covid-19 lockdowns. After eight years of 
                  unchallenged growth in China, regulatory bodies decided in 2021 to ban 
                  all crypto currency transactions, making them illegal on mainland China.
                  <br></br>
                </p>
                <p className="font-weight-normal">
                  Li Lin did not want to leave China with his family, he decided to comply 
                  with Chinese regulators and remove millions of users from the platform 
                  living in mainland China by<a href="https://pandaily.com/huobi-initiates-removal-of-tens-of-millions-of-chinese-users-internal-structure-greatly-adjusted/" 
                  target="_blank" rel="noreferrer" className=" text-info"> December 31, 
                  2021</a> and focus on gaining more international users. Rumors appear 
                  that Li Lin is quietly looking for a buyer of his stake in<a href="https://blockworks.co/news/huobi-founder-sells-100-stake-to-justin-sun-fund-report" 
                  target="_blank" rel="noreferrer" className=" text-info"> &#8220;Huobi&#8221;</a>.
                </p>
                <h3 className="title">
                  The influence of Sun Yuchen &#8220;Justin&#8221;
                </h3>
                <p className="font-weight-normal">
                  Sun Yuchen has been a controversial figure in the blockchain industry 
                  for years. With the suspicious timing of the Wave Field TRON Initial Coin 
                  Offering &#8220;ICO&#8221; being completed and TRON tokens issued the day 
                  before the<a href="https://www.jiemian.com/article/7218691.html" target="_blank" 
                  rel="noreferrer" className=" text-info"> Chinese ICO</a> ban took effect 
                  on September 4, 2017, raising $70 million.
                </p>
                <p className="font-weight-normal">
                  The alleged misappropriation of Poloniex user crypto assets finding their 
                  way into<a href="https://protos.com/sun-bitcoin-operation-couch-cushions-poloniex-users/" 
                  target="_blank" rel="noreferrer" className=" text-info"> Sun Yuchen&#39;s</a> custody 
                  and rumors that Sun Yuchen was the investor using About Capital Management 
                  &#8220;HK&#8221; Co. as an acquisition vehicle for the sale of &#40;Huobi&#41;. 
                  It is unclear exactly how much control Sun Yuchen has over the exchange, but his 
                  unique style can be seen since the sale of &#40;Huobi&#41; in October 2022.
                </p>
                <h3 className="title">
                  Dominica Digital Identity
                </h3>
                <p className="font-weight-normal">
                  An announcement was made on November 29, 2022, that “Huobi” had partnered with TRON 
                  and the<a href="https://protos.com/sun-bitcoin-operation-couch-cushions-poloniex-users/" 
                  target="_blank" rel="noreferrer" className=" text-info"> Commonwealth of Dominica</a> to 
                  issue the Dominica Digital Identities, the launch of this service went live on April 
                  28, 2023.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/dominica.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto" md="8">
                <br></br>
                <p className="font-weight-normal">
                  This announcement was seen as an attempt by &#8220;Huobi&#8221; to start targeting 
                  mainland China users again and avoid China&#39;s crypto asset trading ban, this was 
                  documented in Chinese media in early<a href="https://finance-sina-cn.translate.goog/2023-01-13/detail-imxzyuvx1912511.d.html?_x_tr_sl=zh-CN&_x_tr_tl=en&_x_tr_hl=en&_x_tr_pto=sc" 
                  target="_blank" rel="noreferrer" className=" text-info"> January 2023</a>. Given 
                  Sun Yuchen&#39;s history of avoiding regulation and fondness for small island nations 
                  it would be logical that he had influence over the decision to implement the Dominica 
                  Digital Identity.
                </p>
                <p className="font-weight-normal">
                  This bold new strategy caused Li Lin to file a<a href="https://www.fxstreet.com/cryptocurrencies/news/huobi-founder-li-lin-sues-the-exchange-in-a-hong-kong-court-for-using-the-huobi-trademark-202306212059" 
                  target="_blank" rel="noreferrer" className=" text-info"> trademark</a> dispute lawsuit 
                  against the exchange on June 21, 2023 claiming Huobi Global Limited &#8220;Seychelles&#8221; 
                  had no permission to use the trademark. Later in August 2023 rumors emerged that &#40;Huobi&#41; 
                  executives had been<a href="https://blockcast.it/2023/08/07/huobis-tvl-drops-amid-rumors-of-insolvency-investigations-in-china/" 
                  target="_blank" rel="noreferrer" className=" text-info"> detained in China</a>. These events 
                  ultimately lead to the rebranding of &#40;Huobi&#41; to &#40;HTX&#41;.
                </p>
                <h3 className="title">
                  Why is any of this indicative of a mixing service?
                </h3>
                <p className="font-weight-normal">
                  It isn&#39;t, but it shows there is a certain unwillingness to work with regulators around 
                  the world. This is problematic for the industry&#39;s development. With an exchange of this 
                  size, you would expect it to have a mandatory KYC in place and adequate measures to prevent 
                  criminal activity, this isn&#39;t the case at &#40;HTX&#41;. In fact, all that is needed 
                  to sign up is an email address, you can even sign up using the TOR onion browser to obfuscate 
                  the user&#39;s identity even further.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/htx-tor.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto" md="8">
                <br></br>
                <p className="font-weight-normal">
                  Granted you cannot withdraw fiat currency without uploading KYC documents, but you do get a 
                  daily crypto asset withdrawal limit of 5 BTC, which depending on the value of BTC can be a 
                  substantial amount in fiat currency. You can also create as many of these accounts as you like, 
                  from anywhere in the world including sanctioned jurisdictions. This is where the value of 
                  using &#8220;HTX&#8221; as a crypto asset mixing service is found, as it is regarded as an 
                  exchange which claims to hold regulatory licenses in<a href="https://www.htx.com/en-us/global-licensed-businesses" 
                  target="_blank" rel="noreferrer" className=" text-info"> six jurisdictions</a>, thus giving 
                  the illusion that all crypto assets that are withdrawn from the exchange have no ties to 
                  illicit activity.
                </p>
                <h3 className="title">
                  The &#8220;HTX&#8221; crypto asset mixing example
                </h3>
                <p className="font-weight-normal">
                  The time came to put this to the test, set up a new email account using TOR and the darknet 
                  email service mail2tor&#91;.&#93;com, this was a simple task. Then signed up to the 
                  &#8220;HTX&#8221; platform using the newly created email address.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/sign-up.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto" md="8">
                <br></br>
                <p className="font-weight-normal">
                  The registration confirmation email was in the inbox, and was ready to start 
                  trading &#8220;mixing&#8221;.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/email.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto" md="8">
                <br></br>
                <p className="font-weight-normal">
                  The goal was simple, deposit Bitcoin on the Bitcoin network into the &#8220;HTX&#822; 
                  account, swap the Bitcoin for Tether USD and withdraw the Tether USD on the Tron 
                  blockchain to an external address as &#8220;clean&#8221; tokens. This would conduct 
                  mixing and chain hopping anonymously. Chain hopping is usually done by using various 
                  crypto asset bridging platforms like<a href="https://support.avax.network/en/collections/3073022-avalanche-bridge" 
                  target="_blank" rel="noreferrer" className=" text-info"> Avalanche Bridge</a>.
                </p>
                <p className="font-weight-normal">
                  Depositing the Bitcoin was simple as expected.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/deposit.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto" md="8">
                <br></br>
                <p className="font-weight-normal">
                  Trading the Bitcoin for Tether USD using a market order, the purchaser of the Bitcoin 
                  would assume &#8220;HTX&#8221; had done the relevant due diligence on the maker of the market 
                  order to avoid transacting with any illicit or sanctioned entities.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/mixing.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto" md="8">
                <br></br>
                <p className="font-weight-normal">
                  Withdrawing the Tether USD to the Tron blockchain was processed without any 
                  verification needed, at this point all that was provided to &#8220;HTX&#8221; is 
                  an email address that has no personally identifiable information associated with it.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/withdraw.png")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto mb-5" md="8">
                <br></br>
                <p className="font-weight-normal">
                  With the objective completed, it is difficult to see where, if at all, compliance procedures 
                  were implemented to combat money laundering and terrorist financing using the 
                  FATF&#39;s<a href="https://www.fatf-gafi.org/en/publications/Fatfrecommendations/Guidance-rba-virtual-assets-2021.html" 
                  target="_blank" rel="noreferrer" className=" text-info"> Guidance for a Risk-Based Approach 
                  to Virtual Assets and Virtual Asset Service Providers</a>. TRON (TRX) and the exchange 
                  &#8220;HTX&#8221; have an almost symbiotic relationship with each other which was concerning 
                  even before the recent report by the United Nations Office on Drugs and Crime where it claims 
                  that Tether USD on the TRON blockchain has become the preferred choice for crypto 
                  asset<a href="https://www.unodc.org/roseap/uploads/documents/Publications/2024/Casino_Underground_Banking_Report_2024.pdf" 
                  target="_blank" rel="noreferrer" className=" text-info"> money launderers:</a>
                </p>
                <p className="blockquote font-italic">
                  &#8220;USDT on the TRON blockchain has become a preferred choice for crypto money launderers in East and Southeast 
                  Asia due to its stability and the ease, anonymity, and low fees of its transactions. Law enforcement and financial 
                  intelligence authorities in the region have reported USDT among the most popular cryptocurrencies used by organized 
                  crime groups in the region, particularly those involved in the regional cyberfraud industry, demonstrated by a 
                  surging volume of cases and unauthorized online gambling and cryptocurrency exchange platforms offering underground 
                  USDT-based services.&#8221;
                  <br></br>
                  <br></br>
                  <small>FATF Guidance for a Risk-Based Approach to Virtual Assets and Virtual Asset Service Providers</small>
                </p>
                <h3 className="title">
                  What does it all mean?
                </h3>
                <p className="font-weight-normal">
                  It isn&#39;t, but it shows there is a certain unwillingness to work with regulators around 
                  the world. This is problematic for the industry&#39;s development. With an exchange of this 
                  size, you would expect it to have a mandatory KYC in place and adequate measures to prevent 
                  criminal activity, this isn&#39;t the case at &#8220;HTX&#8221;. In fact, all that is needed 
                  to sign up is an email address, you can even sign up using the TOR onion browser to obfuscate 
                  the user&#39;s identity even further.
                </p>
                <p className="font-weight-normal">
                  As shown above it is easy for anyone in the world to access the &#8220;HTX&#8221; trading 
                  platform, exchange crypto assets across blockchains and move them off the platform without even 
                  giving a name to “HTX”. The process has been completed using three accounts created the same way 
                  as above to ensure that the process remained consistent with each new account created on the 
                  &#8220;HTX&#8221; platform. From intelligence gathering and blockchain analysis active money 
                  launderers were found that use the method above to move crypto assets through the &#8220;HTX&#8221; 
                  platform obfuscating the flow of illicitly gained assets for any investigating law enforcement agency.
                </p>
                <p className="font-weight-normal">
                  It is likely that &#8220;HTX&#8221; enables, and perhaps even encourages illicit actors due to the 
                  seemingly nonexistent compliance protocols for users that do not want to disclose their identities. 
                  The trading platform &#8220;HTX&#8221; is enabled by big names in the industry either through 
                  partnerships or services provided and or supplied. Obfuscation has become the main goal of the 
                  decision makers, there is no public company structure available after 2022. New financial gateways 
                  for users in jurisdictions that &#8220;HTX&#8221; is banned from operating in are being explored 
                  with the addition of the Dominica Digital Identity. All of which suggest avoidance of regulation and 
                  compliance responsibilities.
                </p>
                <p className="font-weight-normal">
                  Deciding if &#8220;HTX&#8221; is a mixing service or not is dependent on what you would consider a 
                  &#8220;mixer&#8221;. Can the trading platform be used anonymously to obfuscate the flow of crypto 
                  assets? Yes, with the bonus of being able to move crypto assets across blockchains and when withdrawn 
                  those crypto assets will look like they came from an exchange.
                </p>
                <p className="font-weight-normal">
                  The key point is the anonymity of the process which prevents illicit actors from being pursued. 
                  Unfortunately, any service that allows for the anonymous movement of crypto assets with a high value 
                  will always be abused by illicit actors to conduct their activities. It is important for the service 
                  provider, in this case &#8220;HTX&#8221; to prevent the abuse of its services and hold those that do 
                  abuse the service accountable.
                </p>
                <p className="font-weight-normal">
                  There is no segregation of user crypto assets or users by jurisdiction, which means that individuals 
                  in the EU, UK and US who have completed the KYC process will inevitably be trading with illicit actors 
                  from sanctioned jurisdiction or entities, darknet marketplace vendors, terrorist organizations and all 
                  other types of organized crime groups. This is somewhat similar to the charges from US agencies that 
                  Binance pleaded guilty to on<a href="https://www.forbes.com/sites/johnhyatt/2023/11/22/binances-changpeng-zhao-clings-to-multibillion-dollar-fortune-after-guilty-plea/" 
                  target="_blank" rel="noreferrer" className=" text-info"> November 21, 2023</a>.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section section-blog">
          <IntelMain />
        </section>
        <section className="section">
          <PreFooter />
        </section>
        <Footer />
      </div>
    </>
  );
}

export default HtxMixingServiceMain;
